import React from 'react';
import { useLang } from '../contexts/LanguageContext';

const Ticker = () => {
  const { t } = useLang();
  const items = [...t.hero.ticker, ...t.hero.ticker];
  return (
    <div className="relative border-y border-cream/10 bg-[#0f1729] overflow-hidden py-6">
      <div className="flex whitespace-nowrap animate-ticker" style={{ direction: 'ltr' }}>
        {items.map((w, i) => (
          <div key={i} className="flex items-center gap-8 px-8">
            <span className="font-serif text-2xl md:text-3xl text-cream/85 font-light italic">{w}</span>
            <span className="w-1 h-1 rounded-full bg-[#c99a3d]/70"></span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Ticker;
